import React, { PropsWithChildren } from 'react';
import styled from 'styled-components';

import ConfiguratorFooter from '../components/ConfiguratorFooter/ConfiguratorFooter';
import { Navigation } from '../components/Navigation/Navigation';

export const Layout: React.FC<PropsWithChildren> = ({ children }) => (
  <AppLayout>
    <Navigation />
    {children}
    <ConfiguratorFooter />
  </AppLayout>
);

const AppLayout = styled.div`
  background-color: ${({ theme }) => `${theme.colors.customGrey4}`};
  display: flex;
  flex-direction: column;
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
`;
